import axios from 'axios';
import router from '../router/index.js';
import {Message} from 'element-ui'
// import { sss } from 'vant';


const instance = axios.create({
  baseURL: 'https://iot.accutargetmed.com/api',
  timeout: 8000,
  // headers:{
  //   'Authorization' : localStorage.getItem('token')
  // }
})

// 在请求拦截器中设置请求头
instance.interceptors.request.use(
  config => {

    //判断vuex是否存有token
    //若存在，则在https请求上加上
    //即使本地存在token，有可能过期，所以在响应拦截器中要对返回状态进行判断
    if(localStorage.getItem('token')){
      config.headers.Authorization = localStorage.getItem('token');
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
)

instance.interceptors.response.use(
  response => {
    //若返回200，说明请求成功
    if(response.status === 200){
      return Promise.resolve(response)
    }else{
      return Promise.reject(response)
    }
  },
  error => {
    if(error.response.status){
      switch(error.response.status) {
        case 401:
          //未登录
          //未登录则跳转至登录，并携带当前路径
          //登录成功后返回当前页面
          Message.error('未登录，请先登录！')
          router.replace('/login')
          break;

        case 403:
          Message.error('权限发生改变，请重新登录')
          router.replace('/login')

          break;

        case 404:
          Message.error('网络请求不存在！')
          break;

        default:
          Message.error(error.response.data.message);
      }

      return Promise.reject(error.response)
    }else{
      //断网 或请求超时，更新state 的network状态
      // network状态在app.vue中控制着一个全局的断网提示组件的显示与隐藏
      // store.commit('changeNetWork',false);
    }
  }

)

export default instance




// WEBPACK FOOTER //
// ./src/api/axios-instance.js